import React from "react";

export type EmptyArt = "cart" | "orders" | "search" | "favorites" | "reviews" | "generic";

const s = { fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round" as const, strokeLinejoin: "round" as const };

/** Line illustrations in the style of the pack label: navy strokes + the logo's diamonds. */
function Art({ kind }: { kind: EmptyArt }) {
  return (
    <svg viewBox="0 0 160 120" className="empty-art" aria-hidden="true">
      <path {...s} d="M18 102h124" opacity=".35" />
      <rect x="26" y="98" width="6" height="6" transform="rotate(45 29 101)" fill="currentColor" />
      <rect x="128" y="98" width="6" height="6" transform="rotate(45 131 101)" fill="currentColor" />
      {kind === "cart" && (
        <>
          <path {...s} d="M50 34h8l9 44h40l8-32H64" />
          <circle {...s} cx="72" cy="90" r="5" />
          <circle {...s} cx="102" cy="90" r="5" />
          <path {...s} d="M84 22v12M78 28h12" opacity=".5" />
        </>
      )}
      {kind === "orders" && (
        <>
          <path {...s} d="M58 22h44v76l-7-5-7 5-8-5-7 5-8-5-7 5z" />
          <path {...s} d="M68 40h24M68 52h24M68 64h14" />
        </>
      )}
      {kind === "search" && (
        <>
          <circle {...s} cx="74" cy="54" r="22" />
          <path {...s} d="M90 70l18 18" />
          <path {...s} d="M66 54c4-6 12-6 16 0" opacity=".5" />
        </>
      )}
      {kind === "favorites" && <path {...s} d="M80 92S50 74 50 52c0-11 8-18 17-18 6 0 10 3 13 8 3-5 7-8 13-8 9 0 17 7 17 18 0 22-30 40-30 40Z" />}
      {kind === "reviews" && (
        <>
          <path {...s} d="M46 30h68v44H74l-14 14V74H46z" />
          <path {...s} d="m80 40 3.5 7 7.5 1-5.5 5.5 1.5 7.5L80 57.5 73 61l1.5-7.5L69 48l7.5-1z" />
        </>
      )}
      {kind === "generic" && (
        <>
          <path {...s} d="M62 30h36l-3 66H65z" />
          <path {...s} d="M66 30v-6h28v6" />
          <rect x="74" y="54" width="12" height="12" transform="rotate(45 80 60)" {...s} />
        </>
      )}
    </svg>
  );
}

export function EmptyState({ title, hint, action, art = "generic" }: { title: string; hint?: string; action?: React.ReactNode; art?: EmptyArt }) {
  return (
    <div className="empty-state">
      <Art kind={art} />
      <h2 style={{ fontSize: 21, margin: "10px 0 6px" }}>{title}</h2>
      {hint && <p style={{ margin: "0 0 18px", fontSize: 14 }}>{hint}</p>}
      {action}
    </div>
  );
}
